import { PropsWithChildren } from 'react';
import { Order } from '../../../../../../../services/exports/Interfaces';
import useAppMethods from '../../../../../../../hooks/utility/useAppMethods';
import { useTranslation } from 'react-i18next';
import useRouter from '../../../../../../../hooks/navigation/useRouter';
import { Modals, Routes } from '../../../../../exports/Enums';
import Button from '../../../../../components/buttons/Button';
import classnames from 'classnames';
import { ORDER_FULFILLMENT_STATUSES } from '../../../../../../../services/exports/Constants';
import useModalRouter from '../../../../../common/hooks/useModalRouter';

type DetailsBtnProps = {
  data: Order;
};

interface Props {
  className?: string;
}

type OrderItemProps = PropsWithChildren & DetailsBtnProps & Props;

const OrderItem = ({ children, data, className }: OrderItemProps): JSX.Element => {
  const { formatCurrency, formatDateTime } = useAppMethods();
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:OrderItem' });

  return (
    <article className={classnames('flex justify-between border-b pb-md w-full', className)}>
      <div className="space-y-3 w-full">
        <div className="space-y-1">
          <div className="flex justify-between gap-sm">
            <h6 className="font-semibold">{t('title', { number: data.fulfillment.number })}</h6>
            <h6 className="text-brand-primary font-semibold">{formatCurrency(data.total)}</h6>
          </div>
          <div className="flex justify-between gap-sm">
            <p className="text-gray-700 text-sm">
              {formatDateTime(data.fulfillment.created_at, { format: 'D MMMM, h:mm A' })}
            </p>
            <p className="text-gray-700 text-sm">{t('labels.item', { count: data.line_items.length })}</p>
          </div>
          <div>
            <p className="!mt-2 text-brand-primary text-xs font-medium">
              {t(`fulfillment_statuses.${data.fulfillment.status}`)}
            </p>
          </div>
        </div>
        {children}
      </div>
    </article>
  );
};

OrderItem.DetailsBtn = ({ data }: DetailsBtnProps) => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Pages:Tabs:Orders:Components:OrderItem' });
  const { navigate } = useRouter();
  const isCompletedOrder = data.fulfillment.status === ORDER_FULFILLMENT_STATUSES.PICKED;
  const { openModal } = useModalRouter();
  const onDetailsClick = () => {
    if (!isCompletedOrder) {
      openModal({
        id: Modals.OrderTracker,
        presentation: null,
        props: {
          uuid: data.uuid,
        },
      });
      return;
    }

    navigate({
      mobile: {
        path: Routes.OrderDetails,
        payload: {
          data,
        },
      },
    });
  };

  return (
    <div className="w-1/2">
      <Button design="secondary" className="w-full" onClick={onDetailsClick} title={t('buttons.details')} />
    </div>
  );
};

export default OrderItem;
